"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _reactIntl = require("react-intl");
var _templateObject, _templateObject2, _templateObject3, _templateObject4;
var HeaderContainer = _styledComponents["default"].div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  margin-bottom: 30px;\n"])));
var Title = _styledComponents["default"].div(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n  font-weight: bold;\n  max-width: 650px;\n  margin: auto;\n  margin-bottom: 10px;\n"])));
var Note = _styledComponents["default"].div(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["\n  font-size: 0.9em;\n  max-width: 650px;\n  margin: auto;\n  margin-bottom: 10px;\n"])));
var Warning = _styledComponents["default"].div(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2["default"])(["\n  font-weight: bold;\n  font-size: 0.9em;\n  max-width: 650px;\n  color: red;\n  margin: auto;\n"])));
var Header = function Header(_ref) {
  var titleId = _ref.titleId,
    titleValues = _ref.titleValues,
    noteId = _ref.noteId,
    warningId = _ref.warningId;
  return _react["default"].createElement(HeaderContainer, null, titleId && _react["default"].createElement(Title, null, _react["default"].createElement(_reactIntl.FormattedMessage, {
    id: titleId,
    values: titleValues
  })), noteId && _react["default"].createElement(Note, null, _react["default"].createElement(_reactIntl.FormattedMessage, {
    id: noteId
  })), warningId && _react["default"].createElement(Warning, null, _react["default"].createElement(_reactIntl.FormattedMessage, {
    id: warningId
  })));
};
var _default = exports["default"] = Header;